import { AuthNavParams } from '@euler/app/flows/auth/Auth';
import { useAuthTheme } from '@euler/app/flows/auth/hooks';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useNavigation } from '@react-navigation/core';
import { StackNavigationProp } from '@react-navigation/stack';
import { FC, memo } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

const kSize = 32;

export const LoginBackButton: FC<{ style?: StyleProp<ViewStyle> }> = memo(
  ({ style }) => {
    const { top } = useSafeAreaInsets();
    const navigation = useNavigation<StackNavigationProp<AuthNavParams>>();
    const theme = useAuthTheme();
    const { rpx } = useResponsiveContext();
    return (
      <TouchableOpacity
        onPress={() => navigation.goBack()}
        css={`
          position: absolute;
          left: ${rpx(32)}px;
          top: ${rpx(32) + top}px;
        `}
        style={[style]}
      >
        <Icon
          name="arrow-left-circle"
          size={rpx(kSize)}
          color={theme.backButtonColor}
        />
      </TouchableOpacity>
    );
  },
);
